<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <v-layout wrap>
          <v-flex xs6 style="padding: 10px">
            <v-layout wrap>
              <v-flex xs6 style="padding-right: 10px">
                <i-datepicker
                    value=""
                    label="Từ ngày"
                    clearable
                    @clearText="clearFromDate"
                    @change="onChangeFromDate"
                />
              </v-flex>
              <v-flex xs6>
                <i-datepicker
                    value=""
                    label="Đến ngày"
                    clearable
                    @clearText="clearToDate"
                    @change="onChangeToDate"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <c-search-form
            :rows-per-page-items="1000"
            :page-size="1000"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="id"
            search-url="/kidClassBabiPro/getAllClassLearnDate?sortField=status,id&"
            create-url=""
            delete-url=""
            form-type="intable"
            custom-create-new
            custom-edit-item
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :acceptView="false"
            :accept-edit="false"
            :accept-create="false"
            :acceptExport="11"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/topic/TopicCreate";
import {statusMHBL} from "@/constants/areaConstants";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Báo cáo lịch giáo viên theo ngày",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      programName: null,
      programId: null,
      ageId: null,
      ageName: null,
      levelNumber: null,
      levelId: null,
      fromDate: null,
      toDate: null,
      weekTotal: null,
      hiddenFields: {
        typeId: "0",
        fromDate: null,
        toDate: null,
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'className',
          text: 'Mã_lớp',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 10%;",
        },
        {
          value: 'learDateStr',
          text: 'Ngày_học',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 10%;",
        },
        {
          value: 'programTimeName',
          text: 'Giờ_học',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 10%;",
        },
        {
          value: 'numberDate',
          text: 'Thứ_học',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 10%;",
        },


        {
          value: 'teachersName1',
          text: 'Tên_GV',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'teacherTypeStr',
          text: 'Dạng_GV',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'lessonCode',
          text: 'Lesson_Code',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },




       /* {
          value: 'classIdPro',
          text: 'ID_lớp',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 10%;",
        },
        {
          value: 'startDateStr',
          text: 'Ngày_khai_giảng',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 10%;",
        },
        {
          value: 'scheduleNumber',
          text: 'Buổi_học',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },*/

      ],
    };
  },

  created() {
  },


  methods: {

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },

    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    clearFromDate() {
      this.hiddenFields.fromDate = new Date();
    },
    clearToDate() {
      this.hiddenFields.toDate = new Date();
    },

    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/tracking/view/' + item.userName,
        query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
